import React, { useState, useEffect } from "react";
import HeatmapTable, { hexToStatus } from "../heatmap/HeatmapTable";
import Loading from "../../../../common-components/Loading";
import { getL2HeatmapCurrentMonthAPI } from "../../../../api/reports-api";

const COLS = [
  { key:"cmRevActuals", label:"Curr Month Contract\nRevenue Actuals", w:170, isCurrency:true  },
  { key:"cmRevBudget",  label:"Curr Month Contract\nRevenue Budget",  w:170, isCurrency:true  },
  { key:"cmGm",         label:"Curr Month GM",                        w:115, isCurrency:true  },
  { key:"cmGmBudget",   label:"Curr Month GM Budget",                 w:135, isCurrency:true  },
  { key:"vacantFTEs",   label:"Vacant FTEs",                          w:90,  isCurrency:false },
];

const MONTH_NAMES = ["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec"];

function mapRow(r) {
  return {
    id: r.clin, projectName: r.projectName, pm: r.programManager,
    cmRevActuals: r.contractRevenue, cmRevBudget: r.contractRevenueBudget,
    cmGm: r.grossMargin, cmGmBudget: r.grossMarginBudget,
    vacantFTEs: r.vacantFte,
    financial: hexToStatus(r.financial), performer: hexToStatus(r.perform), funding: hexToStatus(r.funding),
    staffing: hexToStatus(r.staffing), culture: hexToStatus(r.culture), customer: hexToStatus(r.customer), doge: hexToStatus(r.doge),
  };
}

function mapTotal(t) {
  return {
    cmRevActuals: t.contractRevenue, cmRevBudget: t.contractRevenueBudget,
    cmGm: t.grossMargin, cmGmBudget: t.grossMarginBudget, vacantFTEs: t.vacantFte,
    financial: null, performer: null, funding: null, staffing: null,
    culture: null, customer: null, doge: null,
  };
}

export default function CurrentMonthL2Heatmap({ filters, onMeta }) {
  const programManager = filters?.programManager || [];
  const [loading,  setLoading]  = useState(true);
  const [rows,     setRows]     = useState([]);
  const [totalRow, setTotalRow] = useState(null);
  const [title,    setTitle]    = useState("Current Month L2 Report");

  useEffect(() => {
    let cancelled = false;
    setLoading(true);
    getL2HeatmapCurrentMonthAPI({ year: filters?.year, programManager })
      .then((res) => {
        if (cancelled) return;
        const d = res?.data;
        if (d) {
          setRows((d.rows || []).map(mapRow));
          setTotalRow(mapTotal(d.totals || {}));
          const mo =
            d.actualThroughMonth > 0
              ? MONTH_NAMES[d.actualThroughMonth - 1]
              : "";
          setTitle(`Current Month L2 Report — ${mo} ${d.fiscalYear}`);
          onMeta?.({
            actualThroughMonth: d.actualThroughMonth,
            fiscalYear: d.fiscalYear,
          });
        }
      })
      .catch(() => {})
      .finally(() => { if (!cancelled) setLoading(false); });
    return () => { cancelled = true; };
  }, [JSON.stringify(filters), programManager]);

  if (loading) return <Loading />;
  return <HeatmapTable title={title} cols={COLS} totalRow={totalRow} rows={rows} />;
}
